import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconUserAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUserAdd"><Path d="M12 20.5H4.5V19.5C4.5 15.3579 7.85786 12 12 12" stroke="currentColor"/><Circle cx="12" cy="7.5" r="4.5" stroke="currentColor"/><Path d="M18.5 12.5V20.5M22.5 16.5H14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconUserAdd;
